module.exports = __webpack_public_path__ + "img/IMG_2419.53d667ac.jpg";